function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12.0001 20C7.58012 20 4.00012 16.42 4.00012 12C4.00012 7.58002 7.58012 4.00002 12.0001 4.00002C16.4201 4.00002 20.0001 7.58002 20.0001 12C20.0001 16.42 16.4201 20 12.0001 20ZM14.7556 7.16111C14.8611 7.05556 15.0056 7 15.1445 7C15.2889 7 15.4278 7.05 15.5389 7.16111L16.8389 8.46112C17.0556 8.67778 17.0556 9.02778 16.8389 9.24445L15.8222 10.2611L13.7389 8.17778L14.7556 7.16111ZM13.6555 10.8555L13.1444 10.3444L8.11104 15.3778V15.8889H8.62216L13.6555 10.8555ZM13.1445 8.77216L7 14.9166V17H9.08334L15.2278 10.8555L13.1445 8.77216Z",
  fill: "#778899",
  fillOpacity: 0.7
});

var SvgEdit24 = function SvgEdit24(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit24, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit_24.8255199e.svg";
export { ForwardRef as ReactComponent };